import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { signOut } from 'aws-amplify/auth';
import fetchAPI from 'utils/http/fetchAPI';
import purgeAuthStorage from 'utils/purgeAuthStorage';

// Fully tears down the user's session
var signOutUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetchAPI('/v2/logout', {
            method: 'POST'
          });
        case 3:
          _context.next = 7;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
        case 7:
          // 2. Legacy cookies + sessionStorage. Amplify's own token cookies are intentionally left
          //    to Amplify's signOut below, which still needs the tokens to revoke the refresh token
          //    and to run the Hosted-UI logout redirect; it clears those cookies itself before
          //    redirecting.
          purgeAuthStorage();

          // 3. Revoke this session's refresh token at Cognito, clear the token cookies, and
          //    redirect through the Hosted-UI logout endpoint.
          _context.prev = 8;
          _context.next = 11;
          return signOut();
        case 11:
          _context.next = 15;
          break;
        case 13:
          _context.prev = 13;
          _context.t1 = _context["catch"](8);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5], [8, 13]]);
  }));
  return function signOutUser() {
    return _ref.apply(this, arguments);
  };
}();
export default signOutUser;